import { Seo } from 'ui-components'
import StateProvider from '~map-search/states/provider'
import { Main } from './Main'

const App = (props) => {
  const { userGeolocation } = props

  return (
    <StateProvider
      initialState={{
        userGeolocation
      }}
    >
      <Seo
        title='Mapstack Portal - Explore our community maps'
        description='Discover and interact with a wide range of publicly available maps on the Mapstack Portal. Visualize diverse datasets, uncover insights, and share findings effortlessly. Explore maps created by our community today!'
      />
      <Main />
    </StateProvider>
  )
}

export { App }
export default App
